import $ from 'jquery';

const SELECTOR = '.filtered-link-list';

function onDocumentReady() {
	$(SELECTOR).each(initializeElement);
}

function initializeElement(i, el) {
	const $el = $(el);
	$el.on('change', '.link-filter', onChangeFilter);
	$el.on('click', '.toggle-wrapper .cta', onClickToggleMore);
	setElementFilter($el, '');
}

function onClickToggleMore(e) {
	const clicked = $(e.currentTarget);
	const $el = clicked.closest(SELECTOR);

	$el.toggleClass('relax-soft-cap');

	update($el);
}

function hideUnusedRegions(regions) {
  if(regions.length > 0) {
    var regOpts = $('#filter-region option').each((i,opt) => {
      var $opt = $(opt);
      if($opt.val() !== "0" && !regions.includes($opt.val())) {
        $opt.hide();
      } else {
        $opt.show();
      }
    });
  }
}

function hideUnusedDepartments(departments) {
  if(departments.length > 0) {
    var deptOpts = $('#filter-department option').each((i,opt) => {
      var $opt = $(opt);
      if($opt.val() !== "0" && !departments.includes($opt.val())) {
        $opt.hide();
      } else {
        $opt.show();
      }
    });
  }
}

function showAllDepartments(){
  $('#filter-department option').each((i,opt) => {
    $(opt).show();
  });
}

function showAllRegions(){
  $('#filter-region option').each((i,opt) => {
    $(opt).show();
  });
}

function onChangeFilter(e) {
	const select = $(e.currentTarget);
	setElementFilter(select.closest(SELECTOR), select.val());
}

function setElementFilter($el, filter) {
  var dept = $('#filter-department :selected').val();
  var reg = $('#filter-region :selected').val();

  var activeDepartments = [];
  var activeRegions = [];

  //limitOtherDropdown($el, filter);

  var links_matched = 0;

  const links = $el.find('.link');
	const softCap = $el.attr('data-soft-cap');

	$el.removeClass('has-soft-cap relax-soft-cap');
	$el.toggleClass('has-filter', !!filter);

	links.each((i, link) => {
		const $l = $(link);
    var ldept = link.getAttribute('data-department');
    var lreg = link.getAttribute('data-region');
    var test = (dept === '0' || ldept === dept) && (reg === '0' || lreg === reg);
		if(test) { links_matched += 1; }
    if(ldept === dept) {
      activeRegions.push(lreg);
    }
    if(lreg === reg) {
      activeDepartments.push(ldept);
    }
    $l
		.toggleClass('over-soft-cap', links_matched > softCap)
		.toggleClass(
			'match-filter',
		  test
    );

		$el.toggleClass('has-soft-cap', $el.find('.match-filter').length > softCap);
		if(links_matched > 0) {
			$('.toggle-no-results').hide();
		}
		else {
			$('.toggle-no-results').show();
		}
  });

  if(reg !== "0") {
    hideUnusedDepartments(activeDepartments);
  } else {
    showAllDepartments();
  }
  if(dept !== "0") {
    hideUnusedRegions(activeRegions);
  } else {
    showAllRegions();
  }
	update($el);
}

function update($el) {
	$el.find('.link').each((i, link) => {
		const $l = $(link);

		if (
			($el.hasClass('has-filter') && !$l.hasClass('match-filter')) ||
			($el.hasClass('has-soft-cap') &&
				!$el.hasClass('relax-soft-cap') &&
				$l.hasClass('over-soft-cap'))
		) {
			$l.hide();
		} else {
			$l.show();
		}
	});

	const cta = $el.find('.toggle-wrapper .cta');
	const isRelaxed = $el.hasClass('relax-soft-cap');

	cta.toggleClass('active', isRelaxed);

	if (isRelaxed) {
		cta.text('View Less -');
	} else {
		cta.text('View More +');
	}
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
